// Client-side memory of the visitor's own bookings (access tokens) per
// studio. Every access is guarded: storage can be blocked or wiped.
export interface SavedBooking {
  token: string;
  id: string;
  startsAt: string;
  serviceName: string;
}

const key = (slug: string) => `studio:${slug}:bookings`;

export function savedBookings(slug: string): SavedBooking[] {
  try {
    const raw = localStorage.getItem(key(slug));
    const list = raw ? (JSON.parse(raw) as SavedBooking[]) : [];
    return Array.isArray(list) ? list.filter((b) => typeof b?.token === 'string') : [];
  } catch {
    return [];
  }
}

export function saveBooking(slug: string, b: SavedBooking) {
  try {
    const list = savedBookings(slug).filter((x) => x.id !== b.id);
    list.unshift(b);
    localStorage.setItem(key(slug), JSON.stringify(list.slice(0, 20)));
    window.dispatchEvent(new Event('studio-bookings'));
  } catch {
    /* storage unavailable: the booking link in the confirmation still works */
  }
}

export function forgetBooking(slug: string, id: string) {
  try {
    localStorage.setItem(key(slug), JSON.stringify(savedBookings(slug).filter((x) => x.id !== id)));
    window.dispatchEvent(new Event('studio-bookings'));
  } catch {
    /* ignore */
  }
}

/** Remember the contact details the visitor typed, to prefill next time. */
export function savedContact(): { name: string; phone: string; car: string } {
  try {
    return { name: '', phone: '', car: '', ...JSON.parse(localStorage.getItem('studio:contact') ?? '{}') };
  } catch {
    return { name: '', phone: '', car: '' };
  }
}
export function saveContact(c: { name: string; phone: string; car: string }) {
  try {
    localStorage.setItem('studio:contact', JSON.stringify(c));
  } catch {
    /* ignore */
  }
}
